import { useMemo } from 'react';
import { Button, Flex, Form, Icon, Text } from 'ui';
import { ChatInput, type ChatInputFormValues } from '../chat-input';
import type { PendingMessage, UserToChat } from '../types';
import { ChatCreateUserSelect, useChatCreateUserSelectCreateOption } from './chat-create-user-select';
import type { ChatCreateUserOption } from './chat-create-user-select';
import { useCreateChat } from './hooks';

export type ChatCreateFormValues = {
  members?: ChatCreateUserOption[];
} & ChatInputFormValues;

type P = {
  onClose: () => Promise<void>;
  onCreated: (chatroomId: string, pendingMessage?: PendingMessage) => Promise<void>;
  userToChat?: UserToChat;
};

const ChatCreate = ({ onClose, onCreated, userToChat }: P) => {
  const { createChat, isCreatingChatroom } = useCreateChat({ onCreated });
  const createOption = useChatCreateUserSelectCreateOption();
  const [form] = Form.useForm<ChatCreateFormValues>();
  const members = Form.useWatch('members', form);
  const initialMembers = useMemo(
    () => (userToChat ? [createOption(userToChat)] : undefined),
    [createOption, userToChat],
  );
  const initialValues: Partial<ChatCreateFormValues> = { attachments: [], members: initialMembers };

  return (
    <Form<ChatCreateFormValues> className="chat-create" form={form} initialValues={initialValues} onFinish={createChat}>
      <Flex className="chat-create__content" justify="space-between" vertical>
        <Flex align="center" gap="xxs">
          <Text>To:</Text>
          <Flex flex={1}>
            <Form.Item<ChatCreateFormValues> name="members" noStyle>
              <ChatCreateUserSelect defaultOpen={!userToChat} />
            </Form.Item>
          </Flex>
          <Button aria-label="Close" icon={<Icon icon="close-line" />} onClick={onClose} type="text" />
        </Flex>
        <ChatInput<ChatCreateFormValues> isLoading={isCreatingChatroom} isVisible={Boolean(members?.length)} />
      </Flex>
    </Form>
  );
};

export default ChatCreate;
